import { StackSchemaProps } from '../../components/StackSchema/StackSchema';
import { format, parseISO } from 'date-fns';
import { ContentfulArticle, EntryType } from '@jbhi-fi/apis/src/contentful/types';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export const contentfulApiArticleToStackSchemaProps = (entry: ContentfulArticle): StackSchemaProps | null => {
  const { fields, sys } = entry;
  if (!fields) return null;

  return {
    entryType: EntryType.article,
    heading: fields.heading,
    headline: fields.seoPageTitle || fields.heading,
    parentPage: fields.subCategoryPage?.fields?.heading ?? '',
    description: fields.seoMetaDescription || `${fields.intro ?? ''} · ${documentToPlainTextString(fields.mainBody)}`,
    thumbnailUrl: fields.heroImage?.fields?.file?.url,
    thumbnailHeight: fields.heroImage?.fields?.file?.details?.image?.height?.toString(),
    thumbnailWidth: fields.heroImage?.fields?.file?.details?.image?.width?.toString(),
    datePublished: format(parseISO(sys.createdAt), 'd MMM yy'),
    authorName: fields.author?.fields?.name,
    authorTitle: fields.author?.fields?.title,
    authorImage: fields.author?.fields?.profilePicture?.fields?.file.url,
  };
};
